import React, { forwardRef } from 'react';
import icons from '../../assets/icons/icons.svg';
import { IconWrapper } from './Icon.styles';

type IconName =
  | 'cog'
  | 'dragHandle'
  | 'clipboard'
  | 'code'
  | 'expand'
  | 'cross'
  | 'copy-circle'
  | 'device-mobile'
  | 'device-tablet'
  | 'device-desktop'
  | 'reset-dot'
  | 'cross-circle'
  | 'minus-circle'
  | 'add-circle'
  | 'trash'
  | 'edit-pencil'
  | 'arrow-right'
  | 'arrow-left';

interface IconProps extends React.ComponentPropsWithoutRef<'i'> {
  type: IconName | string;
  height?: number;
  width?: number;
}

const Icon: React.FC<IconProps> = forwardRef<HTMLButtonElement, IconProps>(
  ({ type, height = 24, width = 24, ...props }, ref) => (
    <IconWrapper {...props} ref={ref}>
      <svg height={height} width={width} viewBox={`0 0 ${width} ${height} `}>
        <use href={`${icons}#${type}`} />
      </svg>
    </IconWrapper>
  )
);

export default Icon;
Icon.displayName = 'Icon';
